export interface Resource {
  label: string
  url: string
}

/**
 * "More Resources" guide links shown below the article carousel. Labels and
 * URLs come from the FSM-980 story description set (confirmed by the product
 * owner). URLs point to production smartasset.com guides, matching the
 * match-screen convention for SmartReads content (production-only, not
 * env-specific).
 */
export const MORE_RESOURCES: Resource[] = [
  { label: 'Financial Planning', url: 'https://smartasset.com/financial-advisor' },
  { label: 'Retirement', url: 'https://smartasset.com/retirement' },
  { label: 'Estate Planning', url: 'https://smartasset.com/estate-planning' },
  { label: 'Investing', url: 'https://smartasset.com/investing' }
]
